export default {
  None: 0,
  Favicon: 1,
  Logo: 4,
  LightLogo: 5,
  DarkLogo: 6,
  Font: 8,
  PrimaryFont: 9,
  SecondaryFont: 10,
}
